// react core
import React, { useEffect, useState } from 'react';
// components
import RedirectTo from './redirect_to';
// libs
import { AUTH } from 'api/account';
import { deep_clone_obj } from 'utils/helpers';
// conf
import conf from 'conf/config';

export default function ForceLogin({user, credentials, set_user_data})
{
    const [errors, set_errors] = useState(false);

    useEffect(() =>
    {
        let mounted = true;
        const fetchData = async () =>
        {
            const response = await AUTH.login(credentials.username, credentials.password)
            if (response.ok)
            {
                sessionStorage.setItem('acknowledgement_off', true);
                const data = await response.json();
                if (data.status === 'ok')
                {
                    if (mounted)
                    {
                        let tmp = deep_clone_obj(user);
                        tmp.username = data.userinfo.userid;
                        tmp.fullname = data.userinfo.fullname;
                        tmp.status = 'logged';
                        tmp.ok = true;
                        set_user_data(tmp);
                        set_errors(false);
                    }
                }
                else
                {
                    set_errors(true);
                }
            }

        }
        // call the function
        fetchData()
        // make sure to catch any error
        .catch(console.error);
        return () => mounted = false; // cleanup function
    }, [credentials, user, set_user_data]);

    if(errors)  return (
        <div className='content'>
            Unable to login.
        </div>
    );
    else
    {
        return (<RedirectTo url={conf.server.default_redirect_after_login} />)
    }
};